import { useState, useEffect } from "react";

import Base from "components/Landscape/screens/Base";
import { Navigate } from "react-router-dom";
import { getRefreshTokenCookie } from "lib/Storage";
import ReactGA from 'react-ga';

function LandscapeBase() {
  const AudioContext = window.AudioContext || window.webkitAudioContext;
  const [audioContextInstance, setAudioContextInstance] = useState(
    new AudioContext()
  );
  const [isLandscape, setIsLandscape] = useState(
    window.innerHeight < window.innerWidth
  );

  useEffect(()=>{
    let refreshTokenExists = getRefreshTokenCookie()
    if(!refreshTokenExists){
      // eslint-disable-next-line no-restricted-globals
      location.href="/auth";
    }
  },[])

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsLandscape(window.innerHeight < window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isLandscape ? (
    <Base audioContextInstance={audioContextInstance} />
  ) : (
    <Navigate to="/por" />
  );

  // <DeviceOrientation lockOrientation={"landscape"}>
  //   {/* Will only be in DOM in landscape */}
  //   <Orientation orientation="landscape" alwaysRender={false}>
  //     <Base audioContextInstance ={audioContextInstance} />
  //   </Orientation>
  //   {/* Will stay in DOM, but is only visible in portrait */}
  //   <Orientation orientation="portrait" alwaysRender={false}>
  //     <Redirect to='/por' />
  //   </Orientation>
  // </DeviceOrientation>
}

export default LandscapeBase;
